module.exports = __webpack_public_path__ + "assets/img/sh20.47794145.png";